import http from './http';

/**
 * Busca médicos cuyo nombre/apellido contenga el término (para la búsqueda por nombre).
 * Requiere el endpoint GET /medicos?nombre=... que se agrega al backend en la Etapa 3.
 * Respuesta esperada: [{ id, nombre, apellido, especialidades?, sedes? }]
 */
export async function buscarMedicosPorNombre(nombre) {
  const { data } = await http.get('/medicos', { params: { nombre } });
  return data;
}

/** Lista todos los médicos. */
export async function listarMedicos() {
  const { data } = await http.get('/medicos');
  return data;
}
